import './permissionSwitch.scss';

const PermissionSwitch = ({
  value = 'inactive',
  onChange,
  threeState = false,
  disabled = false,
  className = '',
}) => {
  const handleClick = () => {
    if (disabled || typeof onChange !== 'function') return;

    if (threeState) {
      const next =
        value === 'inactive'
          ? 'active'
          : value === 'active'
            ? 'inactive'
            : 'active';

      onChange(next);
    } else {
      onChange(value === 'active' ? 'inactive' : 'active');
    }
  };

  return (
    <button
      type='button'
      className={[
        'permission-switch',
        `is-${value}`,
        threeState ? 'is-three-state' : '',
        disabled ? 'is-disabled' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={handleClick}
      disabled={disabled}
    >
      <span className='permission-switch__thumb' />
    </button>
  );
};

export default PermissionSwitch;
